export const CANCER_TYPE_PARAM_ID = 20;
export const CANCER_SUBTYPE_PARAM_ID = 21;
export const GENDER_PARAM_ID = 11;
export const AGE_PARAM_ID = 12;
export const ADDITIONAL_INFO_PARAM_ID = 25;
export const ZIP_CODE_PARAM_ID = 22;
export const MAX_DISTANCE_PARAM_ID = 23;
